import React from 'react';
import t from 'prop-types';
import { FormattedMessage } from 'react-intl';

import styles from './EmailInput.scss';

/**
 * @param {string} value - current email value
 * @param {function} onChange
 * @param {?string} error - text of the error, ignored if empty string
 * @param {?boolean} hideLabel
 * @param {?string} className
 * @returns {JSX.Element}
 */
const EmailInput = ({ value, onChange, error, hideLabel = false, className = '' }) => (
  <div className={`${styles.field} ${className || ''}`}>
    {
      !hideLabel && (
        <label htmlFor="email-input-field">
          <FormattedMessage
            id="emailField.defaultLabel"
            defaultMessage="Enter your email"
            description="Default label preceding the email input"
          />
        </label>
      )
    }

    <div className={styles.wrapper}>
      <input
        id="email-input-field"
        type="text"
        placeholder="example@mail.com"
        name="email"
        value={value}
        onChange={onChange}
      />
    </div>

    <div className={styles.error}>{error}</div>
  </div>
);

EmailInput.propTypes = {
  value: t.string.isRequired,
  onChange: t.func.isRequired,
  error: t.string,
  label: t.oneOfType([t.string, t.bool]),
  className: t.string
};

export default EmailInput;
